import { render } from "./App.vue?vue&type=template&id=7c7c9117"
const script = {}
script.render = render

export default script